// Centralized error handling function
export const handleError = (error: any) => {
  console.error("API call failed: ", error); // Log the error details to the console
  if (error.response) {
    // Check if the error has a response from the server
    throw new Error(error.response.data.message || "An error occurred"); // Throw a new error with the server message or a generic message
  }
  throw new Error("Network error"); // Throw a network error if no response is available
};
